import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";

const MyDropzone = props => {
    const { onDropAccepted, children } = props;

    const onDrop = useCallback(acceptedFiles => {
        const files = acceptedFiles.map(file =>
            Object.assign(file, {
                preview: URL.createObjectURL(file)
            })
        );
        onDropAccepted(files);
    }, [onDropAccepted]);
    const { getRootProps, getInputProps } = useDropzone({
        ...props,
        onDrop
    });

    return (
        <div {...getRootProps()} className="dropzone">
            <input {...getInputProps()} />
            {children}
        </div>
    );
};

export default MyDropzone;
